import type { Tag } from "@/libs/api/types";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export function TagBadge({ color, icon, name }: Tag) {
  return (
    <div
      className="py-0.5 px-2 rounded-full flex items-center gap-2 text-sm text-white"
      style={{
        backgroundColor: color,
        whiteSpace: "nowrap",
      }}
    >
      <FontAwesomeIcon icon={icon as FontAwesomeIconProps["icon"]} />
      {name}
    </div>
  );
}
